// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');

class DaysLeftBar extends React.Component {
    render() {
        const {
            daysLeft,
            progressState,
            onHandleToggleCalendar,
            onHandleToggleRemove,
            isLoadingTargetDate,
            currentState
        } = this.props;

        let toolTip = '';

        if (currentState === 'preApproved') {
            toolTip = (
                <OKTooltip
                    content="mortgageRequestPanel-headerTooltip"
                    modifier="dark-bg"
                    offset={[0, -15]}
                />
            );
        }

        const toolTipSignatureInfo = (
            <OKTooltip
                content="mortgageRequestPanel-tooltipSignatureInfo"
                modifier="dark-bg"
                offset={[0, -15]}
            />
        );

        let textLink = (
            <div className="mortgage-request-target-date-bar__links">
                <div>
                    <OKLink
                        inverse="true"
                        modifier="complementary"
                        onClick={onHandleToggleCalendar}
                    >
                        <FormattedText value="mortgageRequestPanel-daysLeftBarUpdateLink" />
                    </OKLink>
                </div>
                <div>
                    <OKLink
                        inverse="true"
                        modifier="complementary"
                        onClick={onHandleToggleRemove}
                    >
                        <FormattedText value="mortgageRequestPanel-daysLeftBarRemoveLink" />
                    </OKLink>
                </div>
            </div>
        );

        if (isLoadingTargetDate) {
            textLink = <p className="mortgage-request-target-date-bar__white">{formatText('mortgageRequestPanel-updatingText')}</p>;
        }

        return (
            <div>
                <p className="mortgage-request-target-date-bar__text2">
                    {formatText('mortgageRequestPanel-state')} <strong className="mortgage-request-target-date-bar__space-tooltip">{progressState}</strong>
                    {toolTip}
                </p>
                <p className="mortgage-request-target-date-bar__text1">
                    <span className="mortgage-request-target-date-bar__text3">
                        {`${daysLeft} ${formatText('mortgageRequestPanel-days')}`}
                    </span>
                    {` ${formatText('mortgageRequestPanel-forTheSign')}`}
                    {toolTipSignatureInfo}
                </p>
                {textLink}
            </div>
        );
    }
}

DaysLeftBar.propTypes = {
    currentState: PropTypes.string,
    daysLeft: PropTypes.number,
    progressState: PropTypes.string,
    onHandleToggleCalendar: PropTypes.func,
    onHandleToggleRemove: PropTypes.func,
    isLoadingTargetDate: PropTypes.bool,
    mortgageRequestState: PropTypes.object
};

DaysLeftBar.defaultProps = {
    daysLeft: 0,
    progressState: '-'
};

module.exports = DaysLeftBar;
